import httpClient from '../utils/httpClient';

export const findPatientForm = async filter => {
	const { data, error } = await httpClient({
		method: 'get',
		url: `/signbox/patient-forms/${filter.code}`
	});

	return { data, error };
};

export const findPatientFormProtected = async documentData => {
	const { data, error } = await httpClient({
		method: 'get',
		url: `/signbox/patient-forms/${documentData.code}/protected`,
		params: documentData
	});

	return { data, error };
};

export const signature = async documentData => {
	const formData = new FormData();

	if (documentData.files) {
		documentData.files.forEach(file => {
			formData.append('files', file);
		})
	}

	if (documentData.signature_file) {
		formData.append('signature', documentData.signature_file);
	}

	formData.append('recaptcha_token', documentData.recaptcha_token);

	if (documentData.document_number) {
		formData.append('document_number', documentData.document_number);
	}

	if (documentData.answers) {
		formData.append('answers', JSON.stringify(documentData.answers));
	}

	const { data, error } = await httpClient({
		method: 'post',
		url: `/signbox/patient-forms/${documentData.code}/signature`,
		data: formData
	});

	return { data, error };
};
